export interface User {
  uuid: string
  code: string
  name: string
  iconUrl?: string
  division?: {
    displayName: string
  }
  position?: {
    displayName: string
  }
  partnerMember?: boolean
  businessClient?: {
    displayName: string
  }
}

export interface AllProjects {
  scheduledWorkingDays: number
  workingDays: number
  absences: number
  totalWorkingTime: number
  totalActualWorkingHour: number
  timeMismatchFlag: boolean
  missingTaskActualWorkFlag: boolean
  missingActualWorkingHourFlag: boolean
  requestStatus: RequestStatus
  unRequestedHour: number
  requestedHour: number
}

export interface ThisProjectRequestDate {
  actualWorkingDaysCount?: number
  requestedDaysCount?: number
  unRequestedDaysCount?: number
  approvedDaysCount?: number
  unApprovedDaysCount?: number
  sentBackDaysCount?: number
}

export interface ThisProjectRequestTime {
  actualWorkHour?: number
  requestedHour?: number
  unRequestedHour?: number
  approvedHour?: number
  unApprovedHour?: number
  sentBackHour?: number
}

export interface ResourcePlan {
  plannedManPercent?: number
  actualManPercent?: number
  plannedManHour?: number
  actualManHour?: number
}

export enum RequestStatus {
  APPROVED = 'APPROVED',
  UNAPPROVED = 'UNAPPROVED',
  UNREQUESTED = 'UNREQUESTED',
  NONE = 'NONE',
}
export enum TaskActualWorkApprovalStatusRowType {
  DATA = 'data',
  TOTAL = 'total',
}

export class TaskActualWorkApprovalStatusTotalRow {
  type: TaskActualWorkApprovalStatusRowType
  totalActualWorkingHourNotEntered: number
  totalTaskActualWorkNotEntered: number
  totalDiscrepancyBetweenActualWorkingHourAndTaskActualWork: number
  constructor() {
    this.type = TaskActualWorkApprovalStatusRowType.TOTAL
    this.totalActualWorkingHourNotEntered = 0
    this.totalTaskActualWorkNotEntered = 0
    this.totalDiscrepancyBetweenActualWorkingHourAndTaskActualWork = 0
  }
}

export interface TaskActualWorkApprovalStatusRow {
  type: string
  uuid: string
  code: string
  userUuid?: string // for link navigation (duplicate of uuid for clarity)
  division?: string
  position: string
  partnerMember?: boolean
  companyName?: string
  userName: string
  userIconUrl?: string
  discrepancyBetweenActualWorkingHourAndTaskActualWork?: string
  discrepancyActualWorkingHour?: string
  discrepancyTaskActualWork?: string
  requestStatus: RequestStatus
  // All Projects Info
  scheduledWorkingDays?: number
  absences?: number
  workingDays?: number
  totalWorkingTime?: number
  totalActualWorkingHour?: number
  requestedHour?: number
  unRequestedHour?: number
  // This Project Request Date Info
  actualWorkingDaysCount?: number
  requestedDaysCount?: number
  unRequestedDaysCount?: number
  approvedDaysCount?: number
  unApprovedDaysCount?: number
  sentBackDaysCount?: number
  // This Project Request Time Info
  actualWorkHourThisProject?: number
  requestedHourThisProject?: number
  unRequestedHourThisProject?: number
  approvedHourThisProject?: number
  unApprovedHourThisProject?: number
  sentBackHourThisProject?: number
  // Resource Plan Info
  plannedManPercent?: number
  actualManPercent?: number
  plannedManHour?: number
  actualManHour?: number
}

export class TaskActualWorkApprovalStatusSkelton {
  uuid: string
  user?: User
  allProjects?: AllProjects
  thisProjectRequestDate?: ThisProjectRequestDate
  thisProjectRequestTime?: ThisProjectRequestTime
  resourcePlan?: ResourcePlan
}

export interface ClosingData {
  closed: boolean
  uuid?: string
}
